import { Subject } from 'rxjs';
import { filter as filter$ } from 'rxjs/operators';

enum CollectionEvent {
    create = 1,
    delete = 2,
    update = 3,
}

const collectionChangeSubscription = new Subject<{ event: CollectionEvent; data: string }>();
const collectionDeleteSubscription = collectionChangeSubscription.pipe(filter$(x => x.event === CollectionEvent.delete));

export { collectionDeleteSubscription, collectionChangeSubscription, CollectionEvent };
